module.exports = __webpack_public_path__ + "img/supermama.aa690951.svg";